import { IValuationIndicator } from "types/graphqlTypes";

export function verifyIndicatorIsValuationRatio(indicator: IValuationIndicator) {
  const valuationRatios = [
    IValuationIndicator.PriceToBook,
    IValuationIndicator.PriceToSales,
    IValuationIndicator.PriceToEbitda,
    IValuationIndicator.PriceToEps,
    IValuationIndicator.PriceToFreeCashFlow,
    IValuationIndicator.ForwardPeRatio,
    IValuationIndicator.NormalizedPriceToEps,
    IValuationIndicator.PegRatio,
    IValuationIndicator.NormalizedPegRatio,
    IValuationIndicator.PriceToCashFlow,
    IValuationIndicator.BookValuePerShare,
    IValuationIndicator.FundsFromOperationsPerShare,
    IValuationIndicator.EnterpriseValueToRevenue,
    IValuationIndicator.EnterpriseValueToEbitda,
    IValuationIndicator.EnterpriseValueToEbit,
    IValuationIndicator.BuyBackYield,
    IValuationIndicator.DividendYield,
    IValuationIndicator.TotalYield,
    IValuationIndicator.PayoutRatio,
  ];

  return valuationRatios.includes(indicator);
}
